/** GOT Standard PPN Master (user, 2026-11-03): each crop's Standard PPN, under got.locations. */
import { createFileRoute, redirect } from "@tanstack/react-router";
import { useAuth } from "@/features/auth/store";
import { GotPpnStandardMasterPage } from "@/features/got/components/ppn-standards-page";

export const Route = createFileRoute("/_app/masters/got-ppn-standards")({
  beforeLoad: () => {
    if (!useAuth.getState().can("got.locations")) throw redirect({ to: "/" });
  },
  component: Page,
});

function Page() {
  const canManage = useAuth((a) => a.can("got.locations"));
  return <GotPpnStandardMasterPage canManage={canManage} />;
}
